module.exports = function i18n(config = { defaultLocale: 'en', locales: {} }) {
    return (req, res, next) => {
        const langHeader = req.headers['accept-language'];
        let locale = config.defaultLocale;
        if (req.query && req.query.lang && config.locales[req.query.lang]) {
            locale = req.query.lang;
        } else if (langHeader) {
            const parsed = langHeader.split(',')[0].split('-')[0];
            if (config.locales[parsed]) {
                locale = parsed;
            }
        }

        req.locale = locale;
        res.t = function (key, params = {}) {
            const dict = config.locales[locale] || {};
            let str = dict[key] || key;
            for (const [k, v] of Object.entries(params)) {
                str = str.replace(new RegExp(`{${k}}`, 'g'), v);
            }
            return str;
        };

        res.locals = res.locals || {};
        res.locals.t = res.t;
        res.locals.locale = locale;

        next();
    };
};
